<div #tableWrap class="table-wrap">
  <up-table
    class="sticky-enabled"
    [style.height]="rows && rows.length > 6 ? tableHeight : ''"
    fixed-head
    fixed-foot
  >
    <table>
      <thead>
        <tr>
          <!-- Dynamic Column Headers -->
          @for (column of columns;track $index) {
          <th
            class="table-header-th"
            [class.sticky-col-1]="columns?.length > 7 && $index === 0"
            [class.sticky-col-2]="columns?.length > 7 && $index === 1"
            [class.sticky-col-last]="
              columns?.length > 7 && $index === columns.length - 1
            "
          >
            {{ column.key }}
          </th>
          }
        </tr>
      </thead>
      <tbody>
        <!-- Dynamic Rows -->
        @for (row of rows; track $index) {
        <tr>
          <!-- Dynamic Data Cells -->
          @for (column of columns; track $index) {
          <td
            [class.sticky-col-1]="columns?.length > 7 && $index === 0"
            [class.sticky-col-2]="columns?.length > 7 && $index === 1"
            [class.sticky-col-last]="
              columns?.length > 7 && $index === columns.length - 1
            "
          >
            @if(column.value !== 'rateComment'){
            <div>
              @if(column.value !== 'railOriginGroup' && column.value !==
              'railDestinationGroup'){
              <div>
                <div>{{ row[column.value] || '-' }}</div>
              </div>
              } @if(column.value === 'railOriginGroup'){
              <div>
                @if(row['groupIdOrigin']){
                <a
                  class="hyper-link-style"
                  href="#"
                  (click)="
                    onRowClick(row[column.value], row['groupIdOrigin']);
                    $event.preventDefault()
                  "
                  (keydown.enter)="
                    onRowClick(row[column.value], row['groupIdOrigin'])
                  "
                  (keydown.space)="
                    onRowClick(row[column.value], row['groupIdOrigin']);
                    $event.preventDefault()
                  "
                >
                  {{ row[column.value] || '-' }}
                </a>
                } @if(!row['groupIdOrigin']){
                <div>{{ row[column.value] || '-' }}</div>
                } @if(row['originDetails'] || row['groupIdOrigin']){
                <up-tooltip placement="top">{{
                  row['originDetails'] || row['groupIdOrigin']
                }}</up-tooltip>
                }
              </div>
              } @if(column.value === 'railDestinationGroup'){
              <div>
                @if(row['groupIdDestination']) {
                <a
                  class="hyper-link-style"
                  href="#"
                  (click)="
                    onRowClick(row[column.value], row['groupIdDestination']);
                    $event.preventDefault()
                  "
                  (keydown.enter)="
                    onRowClick(row[column.value], row['groupIdDestination'])
                  "
                  (keydown.space)="
                    onRowClick(row[column.value], row['groupIdDestination']);
                    $event.preventDefault()
                  "
                >
                  {{ row[column.value] || '-' }}</a
                >
                } @if(!row['groupIdDestination']){
                <div>{{ row[column.value] || '-' }}</div>
                } @if(row['destinationDetails'] || row['groupIdDestination']){
                <up-tooltip placement="top">{{
                  row['destinationDetails'] || row['groupIdDestination']
                }}</up-tooltip>
                }
              </div>
              }
            </div>
            } @if(column.value === 'rateComment'){ @if(!row['rateComment']){
            <ng-container>-</ng-container>
            } @if(row['rateComment']){
            <div class="comment-wrapper">
              <div class="truncated-comment-with-tooltip">
                {{ row['rateComment'] | slice : 0 : 100 }}
                @if(row['rateComment'].length > 100){
                <span>...</span>
                }
                <up-tooltip placement="top">{{
                  row['rateComment']
                }}</up-tooltip>
              </div>
            </div>
            } }
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </up-table>
</div>
